import {ADate} from '@mintdata/mint-kit/api/values/ADate';
import {ADateTime} from '@mintdata/mint-kit/api/values/ADateTime';
import {ATime} from '@mintdata/mint-kit/api/values/ATime';

// export const Date1900 = new Date(1900, 0, 1, 0, 0, 0, 0).valueOf();

const oneSecondMilliseconds = 1000;
const oneMinuteMilliseconds = 60 * oneSecondMilliseconds;
const oneHourMilliseconds = 60 * oneMinuteMilliseconds;
const oneDayMilliseconds = 24 * oneHourMilliseconds;

const currentTimezoneOffsetInMilliseconds = (new Date()).getTimezoneOffset() * oneMinuteMilliseconds;

export class ExcelDateTimeUtil
{
    public static excelDateToADate(excelDate:number):ADate
    {
        const date = ExcelDateTimeUtil.excelDateToJsDate(excelDate);
        return ADate.fromJSDate(date);
    }

    public static excelDateToADateTime(excelDate:number):ADateTime
    {
        const date = ExcelDateTimeUtil.excelDateToJsDate(excelDate);
        return ADateTime.fromJSDate(date);
    }

    public static excelTimeToATime(excelTime:number):ATime
    {
        return ATime.fromExcelTime(excelTime);
    }

    public static excelDateToJsDate(excelDate:number):Date
    {
        // const addOn = (excelDate <= 62) ? 2 : 1;
        //
        // const totalMilliseconds = Date1900 + ExcelDateTimeUtil.fromExcelDuration(excelDate - addOn - 1);
        //
        // const date = new Date(totalMilliseconds);
        // return date;

        // https://stackoverflow.com/questions/16229494/converting-excel-date-serial-number-to-date-using-javascript
        // milliseconds since 1899-31-12T00:00:00Z, corresponds to xl serial 0.
        const xlSerialOffset = -2209075200000;

        let elapsedDays;
        // each serial up to 60 corresponds to a valid calendar date.
        // serial 60 is 1900-02-29. This date does not exist on the calendar.
        // we choose to interpret serial 60 (as well as 61) both as 1900-03-01
        // so, if the serial is 61 or over, we have to subtract 1.
        if( excelDate < 61 )
        {
            elapsedDays = excelDate;
        }
        else
        {
            elapsedDays = excelDate - 1;
        }

        // javascript dates ignore leap seconds
        // each day corresponds to a fixed number of milliseconds:
        // 24 hrs * 60 mins * 60 s * 1000 ms
        // var millisPerDay = 86400000;

        const jsTimestamp = xlSerialOffset + elapsedDays * oneDayMilliseconds + currentTimezoneOffsetInMilliseconds;
        // const jsTimestamp = xlSerialOffset + elapsedDays * oneDayMilliseconds;
        return new Date(jsTimestamp);
    }

    public static fromExcelDuration(excelDate:number):number
    {
        const totalMilliseconds = excelDate * oneDayMilliseconds;
        return totalMilliseconds;
    }
}
